import { render, staticRenderFns } from "./snippet.vue?vue&type=template&id=51578dfe"
import script from "./snippet.vue?vue&type=script&lang=js"
export * from "./snippet.vue?vue&type=script&lang=js"
import style0 from "./snippet.vue?vue&type=style&index=0&id=51578dfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports